import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Stack } from '@mui/material';
// components
import Logo from '../components/Logo';
import Image from '../components/Image';
import useAuth from '../hooks/useAuth';
import { APP_NAME } from '../config';
// assets
// unused import removed

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        minHeight: '100vh',
    },
}));

const SectionStyle = styled('div')(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        position: 'sticky',
        top: 0,
        height: '100vh',
        width: '50%',
        maxWidth: '50%',
        backgroundColor: '#1A202C', // Dark background from design
    },
}));

const ContentStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3),
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.up('md')]: {
        width: '50%',
        maxWidth: '50%',
        padding: theme.spacing(8),
    },
}));

// ----------------------------------------------------------------------

AuthLayout.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    illustration: PropTypes.string,
};

export default function AuthLayout({ children, title, illustration }) {
    const { setting } = useAuth();
    const appName = setting?.general?.app_name || APP_NAME;

    return (
        <RootStyle>
            <SectionStyle>
                <Stack
                    spacing={3}
                    sx={{
                        zIndex: 9,
                        position: 'relative',
                        textAlign: 'center',
                        color: 'common.white',
                        px: 5,
                        alignItems: 'center'
                    }}
                >
                    <Box sx={{ mb: 3 }}>
                        <Logo sx={{ width: 120, height: 120 }} />
                    </Box>
                    <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                        Get Started with {appName.toUpperCase()}
                    </Typography>
                    <Typography variant="body1" sx={{ maxWidth: 480, opacity: 0.8, mx: 'auto' }}>
                        Seamless Payments, Boundless Growth. Experience the next generation of digital finance.
                    </Typography>
                    
                    <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 5 }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'primary.main' }} />
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'grey.600' }} />
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'grey.600' }} />
                    </Stack>
                </Stack>
            </SectionStyle>

            <ContentStyle>
                <Box sx={{ width: '100%', maxWidth: 480, margin: 'auto' }}>
                    {/* Top Logo for Mobile */}
                    <Box sx={{ display: { xs: 'block', md: 'none' }, mb: 5, textAlign: 'center' }}>
                         <Logo sx={{ width: 64, height: 64, mx: 'auto' }} />
                    </Box>
                    {children}
                    <Typography variant="caption" sx={{ mt: 5, display: 'block', textAlign: 'center', color: 'text.secondary' }}>
                        © {appName.toUpperCase()} {new Date().getFullYear()}
                    </Typography>
                </Box>
            </ContentStyle>
        </RootStyle>
    );
}
